// Vote page: the server-list sites the team has set up, each with its own link and note.
import { Link } from "react-router-dom";
import { Icon } from "../icons";
import { EmptyState, Skeleton, useApi } from "../ui";
import { ErrorState } from "../ui/kit";
import { AreaGate, SiteShell } from "./SiteShell";

type VoteSite = { name: string; url: string; note: string };

export function VotePage() {
  return <AreaGate id="public.vote"><SiteShell><VoteBody/></SiteShell></AreaGate>;
}

function VoteBody() {
  const state = useApi<{ sites: VoteSite[] }>("/api/v1/public/vote");
  const sites = state.data?.sites || [];
  return <main id="main">
    <div className="container page-top"><header className="page-head"><h1>Vote for SkyBoxy</h1><p>A vote takes about a minute and helps new players find the server.</p></header></div>
    <section className="band" aria-labelledby="vote-sites">
      <div className="container vote-layout">
        <div className="vote-why">
          <h2 id="vote-sites">Where to vote</h2>
          <p>Server lists sort servers by how many votes they get, and plenty of players pick a new server from the top of those lists. Each vote moves SkyBoxy a little higher. Every site has its own limit on how often you can vote, shown next to it.</p>
        </div>
        <div>
          {state.loading && !state.data ? <Skeleton rows={2} label="Loading voting sites"/>
            : state.error ? <ErrorState error={state.error} fallback="The voting sites could not be loaded right now. Try again in a few minutes."/>
            : !sites.length ? <EmptyState icon="star" title="No voting sites yet" description="The team has not added any server lists yet. Check back soon." action={<div className="empty-actions"><Link className="button" to="/">Back to the home page</Link></div>}/>
            : <ol className="vote-list">{sites.map((site, index) => <li key={`${site.url}-${index}`}>
              <span className="vote-number" aria-hidden="true">{index + 1}</span>
              <div><h3>{site.name}</h3>{site.note && <p>{site.note}</p>}</div>
              <a className="button" href={site.url} target="_blank" rel="noopener noreferrer"><Icon name="external" size={16}/>Vote<span className="sr-only"> on {site.name} (opens in a new tab)</span></a>
            </li>)}</ol>}
        </div>
      </div>
    </section>
  </main>;
}
